import { create } from 'zustand';

type AuthState = {
  isAuthed: boolean;
  username: string | null;
  setAuthenticated: (username: string | null) => void;
  clearAuth: () => void;
};

function loadString(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function saveString(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // ignore storage failures
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthed: loadString('argus_authed') === '1',
  username: loadString('argus_username'),
  setAuthenticated: (username) => {
    saveString('argus_authed', '1');
    if (username) saveString('argus_username', username);
    set({ isAuthed: true, username: username ?? null });
  },
  clearAuth: () => {
    saveString('argus_authed', null);
    saveString('argus_username', null);
    set({ isAuthed: false, username: null });
  },
}));
